import { useDashboardQuery, useMeQuery } from '@Store/api'

import PricePositionSummary from './PricePositionSummary'
import ProductsSidebarLoading from './ProductsSidebarLoading'
import OutOfStock from '../dashboard/out-of-stock'
import PriceChanges from '../dashboard/price-changes'

function ProductsSidebar(): JSX.Element {
  const { data: dashboardData, isLoading: isDashboardDataLoading } =
    useDashboardQuery()
  const { currentData: user, isLoading: isUserLoading } = useMeQuery()

  if (isUserLoading || isDashboardDataLoading) {
    return <ProductsSidebarLoading />
  }

  return (
    <>
      <div className="pb-4">
        <PriceChanges changes={dashboardData?.price_changes} view="Products" />
      </div>
      <div className="pb-4">
        <OutOfStock
          outOfStock={dashboardData?.out_of_stock}
          company={user}
          view="Products"
        />
      </div>
      <div>
        <PricePositionSummary
          position={dashboardData?.position}
          view="Products"
        />
      </div>
    </>
  )
}

export default ProductsSidebar
